import { render } from "./Layout.vue?vue&type=template&id=2dc066f8&scoped=true&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=2dc066f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc066f8"]])

export default __exports__